import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand Column */}
          <div className="space-y-4">
            <img 
              src="/assets/img/brand/logo-light.png" 
              alt="Trademark Law Associates" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-400 leading-relaxed">
              Protecting your intellectual property and securing your business future with expert trademark and copyright services.
            </p>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-emerald-400">Our Services</h4>
            <ul className="space-y-2">
              <li>
                <a href="/trademark-registration" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Trademark Registration
                </a>
              </li>
              <li>
                <a href="/copyright-registration" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Copyright Registration
                </a>
              </li>
              <li>
                <a href="/business-formation" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Business Formation
                </a>
              </li>
              <li>
                <a href="/trademark-search" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Trademark Search
                </a>
              </li>
              <li>
                <a href="/amazon-brand-registry" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Amazon Brand Registry
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links Column */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-emerald-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="/about-us" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="/contact-us" className="text-gray-400 hover:text-emerald-400 transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-emerald-400">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="text-emerald-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">
                  1423 Broadway<br />
                  Oakland, CA 94612, USA
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="text-emerald-400 flex-shrink-0" size={20} />
                <span className="text-gray-400">+1 (833) 202-9624</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="text-emerald-400 flex-shrink-0" size={20} />
                <span className="text-gray-400">info@trademarklawassociates.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © 2025 Trademark Law Associates. All rights reserved.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="/privacy-policy" className="text-gray-400 hover:text-emerald-400 transition-colors">
                Privacy Policy
              </a>
              <a href="/terms-conditions" className="text-gray-400 hover:text-emerald-400 transition-colors">
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
